// Мессенджер целиком работает в браузере: серверный рендеринг и предгенерация
// страниц ему не нужны — весь интерфейс появляется только после авторизации.
export const ssr = false;
export const prerender = false;
export const trailingSlash = 'never';
